(ns ui.components.radix-ui.radio-group.view
  (:require
   ["@radix-ui/react-radio-group" :as RadioGroup]
   [reagent.core :as r]))

(defn adapt
  [cls-name]
  (r/adapt-react-class (aget RadioGroup cls-name)))

(def radio-group-root (adapt "Root"))
(def radio-group-item (adapt "Item"))
(def radio-group-indicator (adapt "Indicator"))
